import { type ReactElement } from 'react';

function HeroLogoBlue(): ReactElement {
    return (
        <svg
            width="756"
            height="197"
            viewBox="0 0 756 197"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-full w-auto"
        >
            <path
                opacity="0.08"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M359.429 751H241.219C108.005 751 0 642.41 0 508.475V210.437C0 195.099 5.9377 180.681 16.7263 169.834L168.774 16.8168C179.562 5.96983 193.903 0 209.158 0H437.852C524.823 0 606.043 34.6464 666.546 97.5695C727.063 160.506 758.766 243.431 755.81 331.073C753.001 414.544 717.958 492.471 657.149 550.491C596.739 608.124 517.574 639.865 434.221 639.865H382.981V727.307C382.981 740.393 372.445 751 359.429 751ZM177.707 179.851V487.444C177.707 538.974 219.258 580.736 270.497 580.736H323.115V512.576C323.115 483.9 346.229 460.66 374.751 460.66H421.087C497.972 460.66 561.762 398.936 562.518 321.635C563.273 243.587 500.331 179.838 422.876 179.838H177.72L177.707 179.851ZM58.8203 211.143V508.475C58.8203 609.589 140.649 691.861 241.219 691.861H324.161L323.115 639.875H270.497C186.892 639.875 118.874 571.489 118.874 487.431V150.717L58.8203 211.143ZM209.874 59.152L148.693 120.713H422.863C532.299 120.713 621.338 210.234 621.338 320.262C621.338 430.291 532.299 519.812 422.863 519.812H381.935V580.736L434.221 580.726C502.438 580.726 567.222 554.755 616.659 507.596C666.188 460.33 694.737 396.941 697.017 329.087C699.429 257.609 673.584 189.995 624.253 138.692C574.936 87.4021 508.733 59.152 437.852 59.152H209.874Z"
                fill="url(#paint0_linear_309_7911)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_309_7911"
                    x1="-9.5"
                    y1="243"
                    x2="756.331"
                    y2="528.11"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#0061FE" stopOpacity="0" />
                    <stop offset="0.442294" stopColor="#0061FE" />
                    <stop offset="1" stopColor="#0061FE" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default HeroLogoBlue;
